<p>
  proposed-discount-list works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/lead/proposed-discount-list/proposed-discount-list.component.html